import React from 'react';
import { ThemeStatusButton } from '../../../Theme/modules/ThemeStatusButton/ThemeStatusButton';
import * as S from './styled';
export const NavbarToolbar = ({ isThemeMain }) => (React.createElement(S.Container, null, isThemeMain && React.createElement(ThemeStatusButton, { isActive: isThemeMain })));
